import CartIcon from 'asset/baga/cart-icon.svg'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { HeaderAction } from 'page/catalog/HeaderAction/HeaderAction'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { opt } from 'store/opt'

type Props = {
  onOpen(): void
}

export const ComboCartAction = observer(({ onOpen }: Props) => {
  const { count } = comboCartStore
  const icon = opt.baga ? <CartIcon /> : <Icon name="shopping_bag" size={20} />

  return <HeaderAction
    icon={icon}
    label={i18n('demo.Cart')}
    badge={count || undefined}
    accent={opt.baga}
    action={onOpen}
  />
})
